import classNames from 'classnames';
import type { FC } from 'react';

import { ourClientsCompaniesList } from '@/assets/clients/our-clients-companies/ourClientsCompaniesList';
import AdamBratt from '@/assets/headshots/adam-bratt.png';
import AlysonWatson from '@/assets/headshots/alyson-watson.png';
import SpencerThomason from '@/assets/headshots/spencer-thomason.png';

import Opinion from './Opinion';

const opinions = [
  {
    name: 'SPENCER THOMASON',
    companyRole: 'Senior Network Engineer, Whitesky Communications',
    opinion:
      'I absolutely recommend MindPal, they’ve been a really great partner for growing business and they’ve really been a team that we can hand any problem that we have and say ‘guys here’s what we’ve got going on’, help us come up with unique and efficient way to solve this.',
    headshots: SpencerThomason,
    companyLogo: ourClientsCompaniesList.whitesky,
  },
  {
    name: 'ADAM BRATT',
    companyRole: 'Product Developer, Benzinga',
    opinion:
      'I found MindPal online first and next I went to Europe to meet the team. I liked what they are doing, seemed they are really good guys. I was also really impressed with the technical talent in Poland. I think the universities and the way the people are taught prepares people more for the real world.',
    headshots: AdamBratt,
    companyLogo: ourClientsCompaniesList.benzinga,
  },
  {
    name: 'ALYSON WATSON',
    companyRole: 'CEO of Modern Health',
    opinion:
      'We are glad to hereby confirm that Modern Health Inc. has successfully cooperated with MindPal during designing and accomplish of our Modern Health platform. We recognized MindPal as a reliable, very helpful partner in business and an expert team in the design and creation of digital products.',
    headshots: AlysonWatson,
    companyLogo: ourClientsCompaniesList.modernHealth,
  },
];

type Props = {
  className?: string;
};

const Opinions: FC<Props> = ({ className }) => {
  return (
    <div
      className={classNames(
        'flex w-full flex-col items-stretch gap-5 lg:flex-row',
        className
      )}
    >
      {opinions.map(
        ({ companyLogo, companyRole, headshots, name, opinion }) => (
          <Opinion
            key={name}
            name={name}
            companyRole={companyRole}
            opinion={opinion}
            headshots={headshots}
            companyLogo={companyLogo}
          />
        )
      )}
    </div>
  );
};

export default Opinions;
